import React from 'react'
import './SignUpOption.css';

export default function HiddenPass() {
  return (
    <div className='hiddenPass'>************</div>
  )
}
